import { useCookieConsentStore } from "@/zapi-frontend/shared/hooks/useCookieConsent";
import { cn } from "@/zapi-frontend/shared/lib/utils";

declare const __COMMIT_HASH__: string;

export function CommitHash({ className }: { className?: string }) {
  const { openConfigureModal } = useCookieConsentStore();

  return (
    <div
      className={cn(
        "text-[14px] text-center text-gray-500 px-2 py-1 rounded shadow-sm flex items-center justify-center gap-3",
        className
      )}
    >
      <span>Version: {__COMMIT_HASH__.slice(0, 7)}</span>
      <span className="text-gray-300">|</span>
      <button onClick={openConfigureModal} className="hover:text-gray-700 hover:underline transition-colors">
        Cookie Settings
      </button>
    </div>
  );
}
